import { useContext } from 'react';

import { Ctx } from '@r1-frontend/entities/ConnectDomruPopup/context';
import { TInitialState } from '@r1-frontend/entities/ConnectDomruPopup/context/initialState';

export const useContextSelector = <T>(selector: (state: TInitialState) => T) => {
    const { state } = useContext(Ctx);
    return selector(state);
};
